const USER_LOCAL_STORAGE_KEYS = [
  'agb-remind-later-timestamp',
  'forum-overview-visited',
  'locale',
  'threadsViewed',
];

export default function clearUserLocalStorage() {
  USER_LOCAL_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}
